import { Observable } from 'rxjs';
import { UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, OnChanges } from '@angular/core';

// custome enums
import { ICountry } from 'src/app/core/interfaces/location/country';

// custome services
import { TopLevelSingleService } from 'src/app/core/services/single-api-top-level-app/singel-top-level.service';

// validations
import { ValidationsPhone } from 'src/app/core/validations/validations-phone';
import OverrideValidators from 'src/app/core/validations/validators-override/validators-override';

@Component({
  selector: 'app-input-phone',
  templateUrl: './input-phone.component.html',
  styleUrls: ['./input-phone.component.scss'],
})
export class InputPhoneComponent implements OnInit, OnChanges, OnDestroy {

  // init props & inputs is coming
  @Input('value') value: any;
  @Input('name') name: string = 'input';
  @Input('type') type: string = 'number';
  @Input('FormParent') FormParent!: UntypedFormGroup
  @Input('validatorsErrorMsg') validatorsErrorMsg: boolean = false;

  
  // init data will outPut
  @Output() formateNumber = new EventEmitter()
  
  /**
   * 
   */
  public CurrentCountry: ICountry = null;

  /**
   * 
   */
  public get Countries$(): Observable<ICountry[]> {
    return this._single.Countries$
  }

  constructor(private _single: TopLevelSingleService) { }

  ngOnChanges() {}

  ngOnInit(): void {}

  // get info country from component drop-dows as outPut
  public CounterSelected(country: ICountry) {

    // emit 
    this.formateNumber.emit(country)

    // update validation phone
    this._updateValidationsPhone(country)

  }

  private _updateValidationsPhone(country: ICountry) {

    // ES6 Destructing
    const { numbersCount } = country || {}
    
    setTimeout(() => {

      this.control.setValidators([
        OverrideValidators.required,
        ValidationsPhone(numbersCount), 
      ]);
  
      // 
      this.control.updateValueAndValidity()

      // 
      this.CurrentCountry = country;

    }, 1)
    
  }
  

  // function will catch all errors in input
  get getError() {
    return (this.FormParent.controls[this.name].errors as ValidationErrors)
  }

  // function will get all date about input
  get control() {
    return this.FormParent.controls[this.name]
  }

  get ErrorMsg() {
    
    if (this.getError) {

      if (Object.keys(this.getError || {}).length > 0 && this.validatorsErrorMsg) {
  
        let msg: any = null;
  
        for (const key in (this.getError || {})) {
          if (this.getError[key]?.toString()) {
            msg = this.getError[key]
            break;
          }
        }
  
        return msg;
  
      }
      
    }

    return null

  }


  ngOnDestroy(): void {}

}
